import React, { FC } from 'react';
import { MenuBlock, MenuItem as MenuItemType } from 'moduleBase/types/Menu';
import { Tab } from 'react-bootstrap';
import { MenuItem } from 'moduleBase/components/menu/MenuItem';
import { SupportInfo } from 'moduleBaseMenu/types/SupportInfo';
import { ToolsContent } from 'moduleBaseMenu/components/mobile/ToolsContent';
import { SupportContent } from 'moduleBaseMenu/components/mobile/SupportContent';
import { FaqContent } from 'moduleBaseMenu/components/mobile/FaqContent';

type PropsType = {
  blocks: MenuBlock[],
  hide: () => void,
  supportInfo: SupportInfo;
  tools: MenuItemType[];
  faq: MenuItemType[];
}

const TabsContent: FC<PropsType> = ({
  blocks,
  hide,
  supportInfo,
  tools,
  faq,
}) => {
  const items = blocks.map((block) => {
    const menuItems = block.items.map((menuItem) => (
      <li className="menu-panel-section" key={`${block.id}-${menuItem.label}`}>
        <MenuItem
          {...menuItem}
          onClick={() => {
            hide();
          }}
          className="menu-panel-link container container-lg-fluid"
        />
      </li>
    ));

    return (
      <Tab.Pane eventKey={block.id} key={block.id}>
        <ul className="list-unstyled mb-0">
          <li className="menu-panel-section">
            <span className="menu-panel-link py-12p container container-lg-fluid fs-22">
              {block.label}
            </span>
          </li>
          {menuItems}
        </ul>
      </Tab.Pane>
    );
  });

  return (
    <Tab.Content className="bg-ivory">
      {items}
      <ToolsContent tools={tools} hide={hide} />
      <SupportContent supportInfo={supportInfo} />
      <FaqContent faq={faq} hide={hide} />
    </Tab.Content>
  );
};

export { TabsContent };
